import { render, staticRenderFns } from "./TopStatistics.vue?vue&type=template&id=39195fb2&scoped=true"
import script from "./TopStatistics.vue?vue&type=script&lang=js"
export * from "./TopStatistics.vue?vue&type=script&lang=js"
import style0 from "./TopStatistics.vue?vue&type=style&index=0&id=39195fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39195fb2",
  null
  
)

export default component.exports